import React, { Component } from 'react'
import { specializationSpeciality } from '@services/api'
import { Collapse, Row, Icon, Popconfirm, Select } from 'antd'
const { Panel } = Collapse
import { inject, observer } from 'mobx-react'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class extends Component {
    state = { addSpeciality: -1, txtFilter: '' }
    render() {
        let { connections, refresh, specialities } = this.props
        let { addSpeciality, txtFilter } = this.state
        let iconStyle = { marginTop: 5, marginRight: 5 }

        return (
            <Collapse accordion style={{ flexDirection: 'column', display: 'flex', flex: 1, width: '100%' }}>
                <Panel header={connections[0].specializationName}>
                    {connections.map(conn => (
                        <Row key={conn.id} gutter={28} style={{ display: 'flex' }}>
                            <p>{conn.specialitiesName}</p>
                            <Popconfirm
                                onConfirm={async () => {
                                    await specializationSpeciality.dlt({ id: conn.id })
                                    refresh()
                                }}
                                okText="אישור"
                                cancelText="ביטול"
                                title={`למחוק קישור בין מומחיות להתמחות?`}
                            >
                                <Icon style={iconStyle} type="delete" onClick={() => {}} />
                            </Popconfirm>
                        </Row>
                    ))}
                    <Row gutter={28} style={{ display: 'flex', marginTop: 12 }}>
                        <input
                            value={txtFilter}
                            onChange={e => this.setState({ txtFilter: e.target.value })}
                            placeholder="סנן מומחות להוספה"
                        />
                    </Row>
                    <Row gutter={28} style={{ display: 'flex' }}>
                        <Select
                            id="set_new"
                            value={addSpeciality}
                            style={{ width: '85%' }}
                            placeholder="קשר מומחיות"
                            onChange={addSpeciality => this.setState({ addSpeciality })}
                        >
                            <Select.Option value={-1} key={'empty'}>
                                בחר מומחיות
                            </Select.Option>
                            {specialities
                                .filter(
                                    sp =>
                                        sp.name.includes(txtFilter) &&
                                        !connections.some(conn => conn.speciality_id == sp.id)
                                )
                                .map(slot => (
                                    <Select.Option value={slot.id} key={slot.id}>
                                        {slot.name}
                                    </Select.Option>
                                ))}
                        </Select>
                        <Icon
                            type="check"
                            style={iconStyle}
                            onClick={async () => {
                                if (addSpeciality + 1) {
                                    await specializationSpeciality.add({
                                        specialization_id: connections[0].specialization_id,
                                        speciality_id: addSpeciality
                                    })
                                    refresh()
                                } else alert('לא ניתן לשמור שדה ריק')
                            }}
                        />
                    </Row>
                </Panel>
            </Collapse>
        )
    }
}
